import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Table, Nav, Row, Col } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

import axios from "axios";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select";
import VideoPlayer from "../../Pages/Home/VideoPlayer";

import LinearProgress from "@mui/material/LinearProgress";
import { useNavigate, useParams } from "react-router-dom";


const ArticleSetting = () => {
    const { id } = useParams();
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [articleOption, setArticleOption] = useState([]);
    const [topArticles, setTopArticles] = useState([]);
    const history = useNavigate();

    useEffect(() => {
        getDropDownArticles();
        singleArticle();
    }, []);
       
    const getDropDownArticles = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getDropDownArticles",
        });

        const output = response.data;

        if (output.length > 0) {
            setArticleOption(
                output.map((option) => ({
                    value: option.pk_ac_key,
                    label: option.ac_name,
                }))
            );
        }
    };

    const singleArticle = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getTopArticle",
            pk_ta_key: id,
        });

        const output = response.data;
        setRows(output);

    };


    const initialValues = {
        pk_ta_key: rows && rows.pk_ta_key ? rows.pk_ta_key : "",
        fk_ac_key: rows && rows.fk_ac_key ? rows.fk_ac_key : "",

    };

    const basicSchema = Yup.object().shape({
        fk_ac_key: Yup.string().required("Article is required.")
        .test("unique-link", "Article is already existing in top articles list", async function (value) {
            if (!value) return true;
            const isArticleUnique = await checkArticleList(value);
            return isArticleUnique;
        }),
    });


    const formik = useFormik({
        initialValues,
        validationSchema: basicSchema,
        onSubmit: async (formValues) => {
            toast.dismiss();
            setIsSubmitting(true);

            const response = await axios.post(
                BASE_URL + "API/apicall",
                {
                    security_key: security_key,
                    mode: "updateTopArticle",
                    ...formValues,
                    pk_ta_key: id,
                },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const output = response.data;
            if (output === 1) {
                toast.success("Updated successfully!");
                setTimeout(() => history("/admin/homepage-settings"), 3000);
            } else {
                toast.error("Oops! Something went wrong.", {
                    autoClose: 3000,
                });
            }
            setTimeout(function () {
                setIsSubmitting(false);
            }, 3000);
        },
    });


    async function checkArticleList(fk_ac_key) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkArticleList",
            fk_ac_key: fk_ac_key,
        });

        const output = response.data;

        return output == 1 ? false : true;
    }

    const { values, handleChange, handleBlur, touched, errors, handleSubmit, setFieldValue, setTouched } = formik;

    const handleCancel = () => {
        history("/admin/homepage-settings");
    };

    return (
        <div className="bg-white p-4">
            <ToastContainer position="top-center" />
            <h4>Edit Setting</h4>
            <Form onSubmit={handleSubmit} ref={formRef}>
                <Select
                    options={articleOption}
                    id="fk_ac_key"
                    name="fk_ac_key"
                    className="w-50 w-sm-100"
                    value={articleOption.find((option) => option.value && values.fk_ac_key && option.value.toString() === values.fk_ac_key.toString())}
                    onChange={(selectedOption) => {
                        const event = {
                            target: {
                                name: "fk_ac_key",
                                value: selectedOption["value"],
                            },
                        };
                        handleChange(event);
                    }}
                    onBlur={(event) => {
                        handleBlur(event);
                        setTouched({ ...touched, fk_ac_key: true });
                    }}
                />
                {errors.fk_ac_key && touched.fk_ac_key && <p className="text-danger">{errors.fk_ac_key}</p>}

                <Button type="submit" className="btn btn-dark mt-3" disabled={isSubmitting}>
                    Save
                    {isSubmitting && <LinearProgress />}
                </Button>
                <Button type="button" className="btn btn-outline-secondary ms-2 mt-3" onClick={handleCancel}>
                    Cancel
                </Button>
            </Form>
        </div>
    );
};

export default ArticleSetting;


